import { render, staticRenderFns } from "./TheCard.vue?vue&type=template&id=0f02daee&scoped=true"
import script from "./TheCard.vue?vue&type=script&lang=ts"
export * from "./TheCard.vue?vue&type=script&lang=ts"
import style0 from "./TheCard.vue?vue&type=style&index=0&id=0f02daee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f02daee",
  null
  
)

export default component.exports